// Mimi Mama – Morning Meadow Character v4
// Works with mimi-shop-tabs section
// Upload to: Assets → mimi-character.js

(function () {
  'use strict';

  const SIZE = 60;

  const SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="64" height="64">
    <defs>
      <filter id="mm-shadow" x="-30%" y="-30%" width="160%" height="160%">
        <feDropShadow dx="0" dy="3" stdDeviation="3" flood-color="#1a5c3a" flood-opacity="0.25"/>
      </filter>
      <radialGradient id="mm-g" cx="38%" cy="32%" r="62%">
        <stop offset="0%" stop-color="#90cda3"/>
        <stop offset="100%" stop-color="#6aaa84"/>
      </radialGradient>
    </defs>
    <circle cx="32" cy="32" r="30" fill="url(#mm-g)" filter="url(#mm-shadow)"/>
    <circle cx="47" cy="38" r="1.4" fill="#4e9068" opacity="0.55"/>
    <circle cx="50" cy="31" r="0.9" fill="#4e9068" opacity="0.45"/>
    <circle cx="48" cy="47" r="1.0" fill="#4e9068" opacity="0.4"/>
    <circle cx="53" cy="41" r="1.1" fill="#4e9068" opacity="0.35"/>
    <circle cx="24" cy="26" r="3.2" fill="#1a1a1a"/>
    <circle cx="40" cy="26" r="3.2" fill="#1a1a1a"/>
    <circle cx="25.3" cy="24.7" r="1" fill="white" opacity="0.75"/>
    <circle cx="41.3" cy="24.7" r="1" fill="white" opacity="0.75"/>
    <rect x="25" y="34" width="14" height="7" rx="3.5" fill="white"/>
    <line x1="32" y1="34" x2="32" y2="41" stroke="#c8a878" stroke-width="1.3"/>
    <ellipse cx="17" cy="32" rx="4" ry="2.5" fill="white" opacity="0.18"/>
    <ellipse cx="47" cy="32" rx="4" ry="2.5" fill="white" opacity="0.18"/>
  </svg>`;

  let el = null;
  let floatTimer = null;
  let hasLanded = false;
  let isAnimating = false;
  let currentBtn = null;

  // ── Easing ──────────────────────────────────────────────────────────────────
  function easeInOut(t) { return t < 0.5 ? 2*t*t : -1+(4-2*t)*t; }
  function bounceOut(t) {
    if (t < 1/2.75) return 7.5625*t*t;
    if (t < 2/2.75) { t-=1.5/2.75; return 7.5625*t*t+0.75; }
    if (t < 2.5/2.75) { t-=2.25/2.75; return 7.5625*t*t+0.9375; }
    t-=2.625/2.75; return 7.5625*t*t+0.984375;
  }

  // ── Land position (fixed coords, centred above button) ──────────────────────
  function landPos(btn) {
    const r = btn.getBoundingClientRect();
    return {
      x: r.left + r.width/2 - SIZE/2,
      y: r.top - SIZE + 4,
    };
  }

  // ── Create element ───────────────────────────────────────────────────────────
  function createEl() {
    const d = document.createElement('div');
    d.id = 'mimi-mama-char';
    d.innerHTML = SVG;
    d.style.cssText = `
      position:fixed;
      width:${SIZE}px;
      height:${SIZE}px;
      left:-${SIZE+60}px;
      top:50vh;
      z-index:99999;
      pointer-events:none;
      transform-origin:center bottom;
      will-change:left,top,transform;
    `;
    document.body.appendChild(d);
    return d;
  }

  // ── Float idle ───────────────────────────────────────────────────────────────
  function stopFloat() { if(floatTimer){clearInterval(floatTimer);floatTimer=null;} }

  function startFloat(x, y) {
    stopFloat();
    let phase = 0;
    const step = (2*Math.PI)/(2000/16);
    floatTimer = setInterval(() => {
      phase += step;
      el.style.top = (y + Math.sin(phase)*5) + 'px';
    }, 16);
  }

  // ── Animate to button ────────────────────────────────────────────────────────
  function flyTo(btn, fromOffscreen) {
    if (!el) return;
    if (isAnimating) return;
    isAnimating = true;
    stopFloat();

    const pos = landPos(btn);
    const dur = fromOffscreen ? 1400 : 520;

    let startX, startY;
    if (fromOffscreen) {
      startX = -SIZE - 60;
      startY = pos.y - 40;
    } else {
      startX = parseFloat(el.style.left) || 0;
      startY = parseFloat(el.style.top)  || 0;
    }

    el.style.left = startX + 'px';
    el.style.top  = startY + 'px';
    const t0 = performance.now();

    function frame(now) {
      const t = Math.min((now - t0) / dur, 1);
      const x = startX + (pos.x - startX) * easeInOut(t);

      let y, sx=1, sy=1, rot=0;
      if (t < 0.55) {
        const p = t/0.55;
        const arc = Math.sin(p*Math.PI) * (fromOffscreen ? 60 : 28);
        y = startY + (pos.y - startY) * easeInOut(p) - arc*(1-p*0.5);
        if (fromOffscreen) rot = Math.sin(t*Math.PI*3)*12*(1-p);
      } else {
        const bp = (t-0.55)/0.45;
        y = pos.y - (1-bounceOut(bp))*40;
        const sq = Math.abs(Math.sin(bp*Math.PI*2));
        sx = 1+sq*0.16; sy = 1-sq*0.12;
      }

      el.style.left      = x+'px';
      el.style.top       = y+'px';
      el.style.transform = `rotate(${rot}deg) scaleX(${sx}) scaleY(${sy})`;

      if (t < 1) {
        requestAnimationFrame(frame);
      } else {
        el.style.left      = pos.x+'px';
        el.style.top       = pos.y+'px';
        el.style.transform = 'none';
        currentBtn = btn;
        hasLanded  = true;
        isAnimating = false;
        startFloat(pos.x, pos.y);
      }
    }
    requestAnimationFrame(frame);
  }

  // ── Expose jump function for tab clicks ─────────────────────────────────────
  window.mimiJumpTo = function (btn) {
    if (!hasLanded) return; // not yet landed, wait
    flyTo(btn, false);
  };

  // ── Watch for section to appear and land on first tab button ─────────────────
  function waitAndLand() {
    // Use mimiGetTabButtons if the tab section is present
    const getter = () => window.mimiGetTabButtons ? window.mimiGetTabButtons() : null;

    // Retry until section renders
    function tryAttach() {
      const btns = getter();
      if (!btns || !btns.shopAll) { setTimeout(tryAttach, 400); return; }

      const target = btns.shopAll;

      const observer = new IntersectionObserver((entries) => {
        for (const e of entries) {
          if (e.isIntersecting && !hasLanded) {
            flyTo(target, true);
            observer.disconnect();
          }
        }
      }, { threshold: 0.95, rootMargin: '0px 0px -20px 0px' });

      observer.observe(target);
    }

    tryAttach();
  }

  // ── Reposition on scroll ─────────────────────────────────────────────────────
  let scrollEnd;
  window.addEventListener('scroll', () => {
    if (!hasLanded || !currentBtn) return;
    stopFloat();
    clearTimeout(scrollEnd);
    scrollEnd = setTimeout(() => {
      const pos = landPos(currentBtn);
      el.style.left = pos.x+'px';
      el.style.top  = pos.y+'px';
      startFloat(pos.x, pos.y);
    }, 80);
  }, { passive: true });

  // ── Pre-landing idle ─────────────────────────────────────────────────────────
  function idleFloat() {
    let phase = 0;
    const t = setInterval(() => {
      if (hasLanded) { clearInterval(t); return; }
      phase += 0.035;
      el.style.top = `calc(50vh + ${Math.sin(phase)*5}px)`;
    }, 16);
  }

  // ── Init ─────────────────────────────────────────────────────────────────────
  function init() {
    el = createEl();
    idleFloat();
    waitAndLand();
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();

})();